import { render, staticRenderFns } from "./RoadmapItem.vue?vue&type=template&id=a9cda936&scoped=true"
import script from "./RoadmapItem.vue?vue&type=script&lang=ts"
export * from "./RoadmapItem.vue?vue&type=script&lang=ts"
import style0 from "./RoadmapItem.vue?vue&type=style&index=0&id=a9cda936&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cda936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9cda936')) {
      api.createRecord('a9cda936', component.options)
    } else {
      api.reload('a9cda936', component.options)
    }
    module.hot.accept("./RoadmapItem.vue?vue&type=template&id=a9cda936&scoped=true", function () {
      api.rerender('a9cda936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/RoadmapItem.vue"
export default component.exports